import { toLonLat } from "ol/proj";
import { BoundaryCodesControl } from "../controls/BoundaryCodesControl";

async function fetchBoundaryCodes(lon, lat, idToken) {
  const url = `${process.env.BOUNDARY_CODES_URL}?lon=${lon}&lat=${lat}`;
  const headers = idToken ? { Authorization: `Bearer ${idToken}` } : {};
  const response = await fetch(url, { headers });
  if (!response.ok) {
    throw new Error(`Failed to fetch boundary codes: ${response.statusText}`);
  }
  return await response.text();
}

export function addBoundaryCodesControl(map, view, target, azureLoginControl) {
  const boundaryCodesControl = new BoundaryCodesControl({
    target: target,
  });

  let debounceTimer;

  view.on("change:center", (event) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      const lonLatCenter = toLonLat(
        event.target.getCenter(),
        event.target.getProjection(),
      );
      const lon = lonLatCenter[0].toFixed(7);
      const lat = lonLatCenter[1].toFixed(7);

      try {
        const idToken = azureLoginControl?.get("idToken");

        // Only fetch if we have a valid token
        if (!idToken) {
          console.warn("No authentication token available");
          boundaryCodesControl.setError("Not authenticated");
          return;
        }

        const codes = await fetchBoundaryCodes(lon, lat, idToken);
        boundaryCodesControl.setBoundaryCodes(codes);
      } catch (error) {
        console.error("Error fetching boundary codes:", error);
        boundaryCodesControl.setError(error.message);
      }
    }, 1000);
  });

  map.addControl(boundaryCodesControl);
}
